import './components/shell/ui/panel';
import { startMainApp } from './core/bootstrap';

startMainApp();
